import * as React from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

// Convierte a mayúsculas y elimina espacios y guiones automáticamente.
export const PlateField = React.forwardRef(
  ({ value, onChange, className, ...props }, ref) => {
    const handle = (e) =>
      onChange?.(e.target.value.toUpperCase().replace(/[\s-]/g, ""));
    return (
      <Input
        ref={ref}
        value={value || ""}
        onChange={handle}
        className={cn("font-mono uppercase", className)}
        {...props}
      />
    );
  }
);
PlateField.displayName = "PlateField";
